import { useBuildex } from "@/hooks/use-buildex";
import { useHealthdex } from "@/hooks/use-healthdex";

const BUILDEX_BLOCKED_ROUTES = ["/dashboard", "/use-cases/enrolment"];
const DEFAULT_ROUTE = "/onboarding/my-data-exchange";

export const useDexGuard = (meta) => {
	const isBuildex = useBuildex();
	const isHealthdex = useHealthdex();
	if (!isBuildex && !isHealthdex) return null;

	const currentPath = meta?.location?.currentPath;

	if (BUILDEX_BLOCKED_ROUTES.includes(currentPath)) {
		return DEFAULT_ROUTE;
	}

	return null;
};
